module.exports = __webpack_public_path__ + "static/media/globulos.17e8a3b8.jpg";